import React, { useContext } from 'react';
import {
  collectSource,
  contentDragSource,
  BaseDraggableSourceProps,
} from '@go-client/lib/feedEditor';
import { DragSource } from 'react-dnd';
import { CONTENT_DND_TYPE } from '@go-client/components/DraggableContentItem';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';
import { generateItineraryWidgetContentTemplate } from '@go-shared/lib/feed';
import { populate as populateSailing, populateDay } from '@go-shared/lib/itinerary';
import { makeSailingDayBundle } from '@go-shared/lib/sailing';

const DraggableItineraryWidget: React.FC<BaseDraggableSourceProps> = ({
  connectDragSource,
  contentTemplate,
}) => {
  return (
    <>
      {connectDragSource(
        <div className="FeedDraggableContentItem p-2 mt-2 cursor-move rounded-sm shadow border-l-8 bg-white">
          <h2 className="font-semibold uppercase">Itinerary Widget</h2>
          <span className="">{contentTemplate && contentTemplate.content}</span>
          <div>
            <span className="text-grey-darkest text-xxs">Display the current itinerary</span>
          </div>
        </div>
      )}
    </>
  );
};

export default (props: BaseDraggableSourceProps) => {
  const { property, sailing, sailingDay } = useContext(FeedEditorCtx);

  const fullSailing = sailing && property ? populateSailing(sailing, property, [], []) : undefined;
  const fullSailingDay = sailingDay ? populateDay(sailingDay, []) : undefined;
  const sailingDayBundle =
    fullSailing && fullSailingDay ? makeSailingDayBundle(fullSailing, fullSailingDay) : undefined;

  return (
    <Source
      {...props}
      contentTemplate={generateItineraryWidgetContentTemplate(property!, sailingDayBundle)}
    />
  );
};
const Source = DragSource(
  CONTENT_DND_TYPE,
  contentDragSource<BaseDraggableSourceProps>(),
  collectSource
)(DraggableItineraryWidget);
